// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_3WsW4W9MCuyd4Nuo1fHOJ9","icon":"_2PAZfLtjueiENkecB_EFc0"};